const regionCountryNAMSet = new Set(["US", "CA"]);
const reqgionCountryEMEASet = new Set(["FR"]);
const isRegionRequired = (countryCode, requireEmeaProvince = false) =>
  regionCountryNAMSet.has(countryCode?.toUpperCase()) ||
  (requireEmeaProvince && reqgionCountryEMEASet.has(countryCode?.toUpperCase()));
export default isRegionRequired;
